import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorage {
 
  constructor() {}


    /**
   * Set an item to localStorage (auto converts object to JSON)
   */
  storeData(key: string, value: any): void {
    try {
      // const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, value);
    } catch (error) {
      console.error(`Error saving ${key} to localStorage`, error);
    }
  }

  /**
   * Get an item from localStorage (auto parses JSON)
   */
 getData(key: string): string | null {
  return localStorage.getItem(key);
}

  /**
   * Remove an item from localStorage
   */
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing ${key} from localStorage`, error);
    }
  }

  /**
   * Clear all localStorage
   */
  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage', error);
    }
  }


}
